export function noDev() {
    if ((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf("IEMobile") !== -1)) {
        $("html").removeClass("no-dev");
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/noDev.js